import { useEffect, useRef } from 'react';

export const useTextareaEffects = (value: string, autoFocus?: boolean) => {
  const ref = useRef<HTMLTextAreaElement | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto'; // reset
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);

  useEffect(() => {
    if (autoFocus && ref.current) {
      ref.current.focus();
      // move cursor to end
      const length = ref.current.value.length;
      ref.current.setSelectionRange(length, length);
    }
  }, [autoFocus]);

  return ref;
};
